export interface Reason {
  title: string
  lines: string[]
}

export interface CourseItem {
  label: string
  title: string
  bullets: string[]
}

export interface Audience {
  role: string
  benefit: string
}

export interface Objection {
  question: string
  answer: string[]
}

export const reasons: Reason[] = [
  {
    title: 'Cuesta $20, no $97',
    lines: [
      'Punto. No hay truco. Otros lo venden caro porque pueden. Yo lo vendo barato porque quiero que lo uses.',
    ],
  },
  {
    title: 'Ahorras 10-15 horas de trabajo a la semana',
    lines: [
      'ChatGPT escribe lo que tú harías en 1 hora, en 5 minutos.',
      'Claude analiza documentos largos en segundos.',
      'Gemini integra con tus apps.',
      'Copilot automatiza tareas en Excel y Word.',
      'Son horas que recuperas. Son dinero que ganas.',
    ],
  },
  {
    title: 'No es teoría, es práctico',
    lines: ['3 PDFs. Pasos concretos. Ejercicios. Nada de conceptos que no sirven.'],
  },
  {
    title: 'Funciona para tu edad',
    lines: [
      '¿16 años? Aprende a escribir mejor, estudia más rápido.',
      '¿52 años? Trabaja como yo, produce más en menos tiempo.',
      '¿60 años? La IA es tu empleada personal.',
      'No hay edad límite.',
    ],
  },
  {
    title: 'Recuperas los $20 en 1 hora',
    lines: [
      'Si lo aplicas bien, ganas más de $20 en tu primer proyecto.',
      'El resto es pura ganancia.',
    ],
  },
]

export const courses: CourseItem[] = [
  {
    label: 'PDF 1',
    title: 'IA para Principiantes',
    bullets: [
      'Qué es la IA realmente',
      'ChatGPT, Claude, Gemini, Copilot: una por una',
      'Cómo escribir prompts que funcionan',
      '10 casos de uso que haces hoy mismo',
    ],
  },
  {
    label: 'PDF 2',
    title: 'IA Avanzada',
    bullets: [
      'Prompting profesional (técnicas que cobran $500/hora)',
      'Crear asistentes personalizados',
      'Automatizar flujos (la IA trabaja mientras duermes)',
      'Documentos, datos, hojas de cálculo',
      'IA multimodal: imágenes, audio, video',
    ],
  },
  {
    label: 'PDF 3',
    title: 'Guía Paso a Paso',
    bullets: [
      '7 módulos con instrucciones concretas',
      'Ética y privacidad (lo que no puedes compartir)',
      'Material de referencia que consultas cuando lo necesitas',
      'Todo descargable. Para siempre.',
    ],
  },
]

export const audiences: Audience[] = [
  {
    role: 'Emprendedor',
    benefit: 'Automatiza tu negocio. Produce más con menos personas.',
  },
  {
    role: 'Freelancer',
    benefit: 'Entrega trabajos mejor y más rápido. Cobra más.',
  },
  {
    role: 'Estudiante (16+)',
    benefit: 'Estudia inteligente. Mejora tus calificaciones en serio.',
  },
  {
    role: 'Creador de contenido',
    benefit: 'Genera ideas, escribe posts, crea imágenes. La IA es tu asistente.',
  },
  {
    role: 'Venezolano que quiere crecer',
    benefit: 'Multiplica tu productividad. La IA es para quien quiere prosperar.',
  },
]

export const objections: Objection[] = [
  {
    question: '¿Es complicado?',
    answer: ['No. El Curso 1 empieza desde cero. Si usas WhatsApp, usas IA.'],
  },
  {
    question: '¿Me va a reemplazar?',
    answer: [
      'No. Va a reemplazar a quien NO la aprenda.',
      'Los que aprenden HOY van a estar en ventaja 5 años.',
    ],
  },
  {
    question: '¿Realmente gano más?',
    answer: [
      'Sí. Si ahorras 10 horas a la semana y ganas $50/hora, eso es $500/semana.',
      '$2,000/mes extra.',
      'Recuperas los $20 en la primera hora.',
    ],
  },
  {
    question: '¿Por qué tan barato?',
    answer: [
      'Porque tengo 52 años y no necesito dinero.',
      'Necesito impacto.',
      'Prefiero 10,000 personas con $20 que 100 personas con $200.',
    ],
  },
  {
    question: '¿Realmente acceso inmediato?',
    answer: ['Sí. Descargas después de pagar. Sin esperas. Sin emails lentos.'],
  },
]
